import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

export const useMenu = () => {
  const history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const setOverflow = () => {
    const body = document.body;
    if (body.style.overflow === 'hidden') {
      body.style.overflow = '';
    } else {
      body.style.overflow = 'hidden';
    }
  };

  const onToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setOverflow();
  };

  const onCloseMenu = useCallback(() => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
  }, []);

  useEffect(() => {
    const unsubscribe = history.listen(onCloseMenu);
    return () => unsubscribe();
  }, [onCloseMenu, history]);

  return { isMenuOpen, onToggleMenu };
};
